import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { SolutionsSection } from '../components/SolutionsSection';
import { PricingSection } from '../components/PricingSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-614" />
      <ServicesSection data-id="element-615" />
      <SolutionsSection data-id="element-616" />
      <PricingSection data-id="element-617" />
    </>;
}